import { render, staticRenderFns } from "./newLoaderIcon.vue?vue&type=template&id=3dcc6dce&scoped=true"
import script from "./newLoaderIcon.vue?vue&type=script&lang=js"
export * from "./newLoaderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcc6dce",
  null
  
)

export default component.exports